import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useInView } from 'react-intersection-observer';

const BackgroundImageContainer = styled.div`
  background-image: url(${({ backgroundImage }) => backgroundImage});
`;

const LazyBackgroundImage = ({ className, backgroundImage, ...rest }) => {
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
    rootMargin: '100%',
  });

  return (
    <BackgroundImageContainer
      className={className}
      ref={inViewRef}
      backgroundImage={inView ? backgroundImage : null}
      {...rest}
    />
  );
};

export default LazyBackgroundImage;
